import axios from "axios";
import { store } from "../redux/store";
import { clearError, logout } from "../features/user/authSlice"; // Import your clearError action
import { clearPharmacyList } from "../features/pharmacy/pharmacySlice";
import { getLeaderboardToken, removeLeaderboardToken } from "../utils/commonFunctions";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

const isLeaderboardPublicPath = () =>
  window.location.pathname.startsWith("/leaderboard");

// Request interceptor to attach token
api.interceptors.request.use(
  (config) => {
    if (isLeaderboardPublicPath()) {
      const leaderboardToken = getLeaderboardToken();
      if (leaderboardToken) {
        config.headers.Authorization = `Bearer ${leaderboardToken}`;
      }
      return config;
    }

    const state = store.getState();
    const token = state.auth?.token; // Use token from auth state (instead of state.auth?.user?.token)
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor to handle token expiration
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      if (isLeaderboardPublicPath()) {
        removeLeaderboardToken();
        if (window.location.pathname !== "/leaderboard") {
          window.location.href = "/leaderboard";
        }
        return Promise.reject(error);
      }

      if (window.location.pathname !== "/login") {
        store.dispatch(clearError());
        store.dispatch(clearPharmacyList());
        store.dispatch(logout());
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default api;
